export const config = {
  storagePrefix: 'ium',
  clientId: window.env.clientId,
  iumBaseUrl: window.env.baseUrl,
  appBaseUrl: window.env.baseUrl,
  refreshInterval: 300000,
};
export default config;